import { createSelector } from 'reselect';
import { downloader, postman } from '../utils/postman';
import { all, cancel, cancelled, delay, fork, put, select, takeEvery } from 'redux-saga/effects';
import { IS_AUTO_UPDATE } from '../constants/settings';
import { formatDate } from '../utils/dateTimeFormater';
import { toast } from 'react-toastify';
import { representationFromGridSelector } from './representations';
import downloadFile from "../utils/downloadFile";
import {ORDERS_GRID} from "../constants/grids";
import { startOfMinute } from 'date-fns';

let task = null;
//let filters = {};

//*  TYPES  *//

const GET_GRID_LIST_REQUEST = 'GET_GRID_LIST_REQUEST';
const GET_GRID_LIST_SUCCESS = 'GET_GRID_LIST_SUCCESS';
const GET_GRID_LIST_ERROR = 'GET_GRID_LIST_ERROR';

const GET_STATE_COLORS_REQUEST = 'GET_STATE_COLORS_REQUEST';
const GET_STATE_COLORS_SUCCESS = 'GET_STATE_COLORS_SUCCESS';
const GET_STATE_COLORS_ERROR = 'GET_STATE_COLORS_ERROR';

const GRID_IMPORT_FROM_EXCEL_REQUEST = 'GRID_IMPORT_FROM_EXCEL_REQUEST';
const GRID_IMPORT_FROM_EXCEL_SUCCESS = 'GRID_IMPORT_FROM_EXCEL_SUCCESS';
const GRID_IMPORT_FROM_EXCEL_ERROR = 'GRID_IMPORT_FROM_EXCEL_ERROR';

const GRID_EXPORT_TO_EXCEL_REQUEST = 'GRID_EXPORT_TO_EXCEL_REQUEST';
const GRID_EXPORT_TO_EXCEL_SUCCESS = 'GRID_EXPORT_TO_EXCEL_SUCCESS';
const GRID_EXPORT_TO_EXCEL_ERROR = 'GRID_EXPORT_TO_EXCEL_ERROR';

const GET_BILL_DETAILS_BY_ID_REQUEST = 'GET_BILL_DETAILS_BY_ID_REQUEST';
const GET_BILL_DETAILS_BY_ID_SUCCESS = 'GET_BILL_DETAILS_BY_ID_SUCCESS';
const GET_BILL_DETAILS_BY_ID_ERROR = 'GET_BILL_DETAILS_BY_ID_ERROR';

const GET_BILL_DETAILS_LIST_REQUEST = 'GET_BILL_DETAILS_LIST_REQUEST';
const GET_BILL_DETAILS_LIST_SUCCESS = 'GET_BILL_DETAILS_LIST_SUCCESS';
const GET_BILL_DETAILS_LIST_ERROR = 'GET_BILL_DETAILS_LIST_ERROR';

const BILL_DETAILS_EXPORT_TO_EXCEL_REQUEST = 'BILL_DETAILS_EXPORT_TO_EXCEL_REQUEST';
const BILL_DETAILS_EXPORT_TO_EXCEL_SUCCESS = 'BILL_DETAILS_EXPORT_TO_EXCEL_SUCCESS';
const BILL_DETAILS_EXPORT_TO_EXCEL_ERROR = 'BILL_DETAILS_EXPORT_TO_EXCEL_ERROR';

const BILL_DETAILS_INVOKE_BULK_UPDATE_REQUEST = 'BILL_DETAILS_INVOKE_BULK_UPDATE_REQUEST';
const BILL_DETAILS_INVOKE_BULK_UPDATE_SUCCESS = 'BILL_DETAILS_INVOKE_BULK_UPDATE_SUCCESS';
const BILL_DETAILS_INVOKE_BULK_UPDATE_ERROR = 'BILL_DETAILS_INVOKE_BULK_UPDATE_ERROR';

const GET_BILL_DETAILS_GRID_CONFIG_REQUEST = 'GET_BILL_DETAILS_GRID_CONFIG_REQUEST';
const GET_BILL_DETAILS_GRID_CONFIG_SUCCESS = 'GET_BILL_DETAILS_GRID_CONFIG_SUCCESS';
const GET_BILL_DETAILS_GRID_CONFIG_ERROR = 'GET_BILL_DETAILS_GRID_CONFIG_ERROR';

const GET_BILL_DETAILS_SUB_GRID_CONFIG_REQUEST = 'GET_BILL_DETAILS_SUB_GRID_CONFIG_REQUEST';
const GET_BILL_DETAILS_SUB_GRID_CONFIG_SUCCESS = 'GET_BILL_DETAILS_SUB_GRID_CONFIG_SUCCESS';
const GET_BILL_DETAILS_SUB_GRID_CONFIG_ERROR = 'GET_BILL_DETAILS_SUB_GRID_CONFIG_ERROR';

const GRID_AUTO_UPDATE_START = 'GRID_AUTO_UPDATE_START';
const GRID_AUTO_UPDATE_STOP = 'GRID_AUTO_UPDATE_STOP';

const SAVE_GRID_FILTERS = 'SAVE_GRID_FILTERS';
const CLEAR_GRID_FILTERS = 'CLEAR_GRID_FILTERS';

const CLEAR_GRID_INFO = 'CLEAR_GRID_INFO';

const DEFAULT_STATE = 'DEFAULT_STATE';

//*  INITIAL STATE  *//

const initial = {
    data: [],
    totalCount: 0,
    stateColors: [],
    titleInfo: '',
    billDetailsList: [],
    billDetailsConfig: {},
    billDetailsSubGridConfig: {},
    progress: false,
    stateColorsProgress: false,
    bulkUpdateProgress: false,
    importProgress: false,
    exportProgress: false,
    filters: {},
};

//*  REDUCER  *//

export default (state = initial, { type, payload }) => {
    switch (type) {
        case GET_GRID_LIST_REQUEST:
            return {
                ...state,
                progress: !payload.notLoader,
            };
        case GET_GRID_LIST_SUCCESS:
            return {
                ...state,
                progress: false,
                totalCount: payload.totalCount,
                data: payload.isConcat ? [...state.data, ...payload.items] : payload.items,
            };
        case GET_GRID_LIST_ERROR:
            return {
                ...state,
                data: [],
                totalCount: 0,
                progress: false,
            };
        case GET_STATE_COLORS_REQUEST:
            return {
                ...state,
                stateColorsProgress: true,
            };
        case GET_STATE_COLORS_SUCCESS:
            return {
                ...state,
                stateColors: payload,
                stateColorsProgress: false,
            };
        case GET_STATE_COLORS_ERROR:
            return {
                ...state,
                stateColors: [],
                stateColorsProgress: false,
            };
        case GRID_IMPORT_FROM_EXCEL_REQUEST:
            return {
                ...state,
                importProgress: true,
            };
        case GRID_IMPORT_FROM_EXCEL_SUCCESS:
        case GRID_IMPORT_FROM_EXCEL_ERROR:
            return {
                ...state,
                importProgress: false,
            };
        case GRID_EXPORT_TO_EXCEL_REQUEST:
            return {
                ...state,
                exportProgress: true,
            };
        case GRID_EXPORT_TO_EXCEL_SUCCESS:
        case GRID_EXPORT_TO_EXCEL_ERROR:
            return {
                ...state,
                exportProgress: false,
            };
        case GET_BILL_DETAILS_BY_ID_REQUEST:
            return {
                ...state
            }
        case GET_BILL_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                titleInfo: payload,
            }
        case GET_BILL_DETAILS_LIST_REQUEST:
            return {
                ...state,
                progress: !payload.notLoader,
            };
        case GET_BILL_DETAILS_LIST_SUCCESS:
            return {
                ...state,
                progress: false,
                totalCount: payload.totalCount,
                billDetailsList: payload,
            };
        case GET_BILL_DETAILS_LIST_ERROR:
            return {
                ...state,
                billDetailsList: [],
                progress: false,
            };
        case BILL_DETAILS_EXPORT_TO_EXCEL_REQUEST:
            return {
                ...state,
                exportProgress: true,
            };
        case BILL_DETAILS_EXPORT_TO_EXCEL_SUCCESS:
        case BILL_DETAILS_EXPORT_TO_EXCEL_ERROR:
            return {
                ...state,
                exportProgress: false,
            };
        case GET_BILL_DETAILS_GRID_CONFIG_REQUEST:
            return {
                ...state,
                progress: true
            }
        case GET_BILL_DETAILS_GRID_CONFIG_SUCCESS:
            return {
                ...state,
                progress: false,
                billDetailsConfig: payload,
            }
        case GET_BILL_DETAILS_GRID_CONFIG_ERROR:
            return {
                ...state,
                progress: false,
                billDetailsConfig: {},
            }
        case GET_BILL_DETAILS_SUB_GRID_CONFIG_REQUEST:
            return {
                ...state,
                progress: true
            }
        case GET_BILL_DETAILS_SUB_GRID_CONFIG_SUCCESS:
            return {
                ...state,
                progress: false,
                billDetailsSubGridConfig: payload,
            }
        case GET_BILL_DETAILS_SUB_GRID_CONFIG_ERROR:
            return {
                ...state,
                progress: false,
                billDetailsSubGridConfig: {},
            }
        case BILL_DETAILS_INVOKE_BULK_UPDATE_REQUEST:
            return {
                ...state,
                bulkUpdateProgress: true,
            }
        case BILL_DETAILS_INVOKE_BULK_UPDATE_ERROR:
        case BILL_DETAILS_INVOKE_BULK_UPDATE_SUCCESS:
            return {
                ...state,
                bulkUpdateProgress: false,
            }
        case  SAVE_GRID_FILTERS:
            return {
                ...state,
                progress: true,
                filters: payload
            };
        case CLEAR_GRID_FILTERS:
            return {
                ...state,
                filters: {}
            };
        case CLEAR_GRID_INFO:
            return {
                ...state,
                ...initial,
            };
        case DEFAULT_STATE:
            return {
                ...initial
            };
        default:
            return state;
    }
};

//*  ACTION CREATORS  *//

export const getListRequest = payload => {
    return {
        type: GET_GRID_LIST_REQUEST,
        payload,
    };
};

export const getStateColorsRequest = payload => {
    return {
        type: GET_STATE_COLORS_REQUEST,
        payload,
    };
};

export const getBillDetailsByIdRequest = payload => {
    return {
        type: GET_BILL_DETAILS_BY_ID_REQUEST,
        payload,
    };
};

export const getBillDetailsListRequest = payload => {
    return {
        type: GET_BILL_DETAILS_LIST_REQUEST,
        payload,
    };
};

export const billDetailsExportToExcelRequest = payload => {
    return {
        type: BILL_DETAILS_EXPORT_TO_EXCEL_REQUEST,
        payload,
    };
};

export const billDetailsInvokeBulkUpdateRequest = payload => {
    return {
        type: BILL_DETAILS_INVOKE_BULK_UPDATE_REQUEST,
        payload,
    };
};

export const getBillDetailsGridConfigRequest = payload => {
    return {
        type: GET_BILL_DETAILS_GRID_CONFIG_REQUEST,
        payload,
    }
}

export const getBillDetailsSubGridConfigRequest = payload => {
    return {
        type: GET_BILL_DETAILS_SUB_GRID_CONFIG_REQUEST,
        payload,
    }
}

export const autoUpdateStart = payload => {
    return { type: GRID_AUTO_UPDATE_START, payload };
};

export const autoUpdateStop = payload => {
    return { type: GRID_AUTO_UPDATE_STOP, payload };
};

export const importFromExcelRequest = payload => {
    return {
        type: GRID_IMPORT_FROM_EXCEL_REQUEST,
        payload,
    };
};

export const exportToExcelRequest = payload => {
    return {
        type: GRID_EXPORT_TO_EXCEL_REQUEST,
        payload,
    };
};

export const clearGridInfo = () => {
    return {
        type: CLEAR_GRID_INFO,
    };
};

//*  SELECTORS *//

const stateSelector = state => state.gridList;
const getKey = (state, key = 'progress') => key;
const stateProfile = state => state.profile;
const gridName = (state, name) => name;

export const columnsGridSelector = createSelector([stateProfile, gridName], (state, name) => {
    const grid = state.grids && state.grids.find(item => item.name === name);
    return grid ? grid.columns : [];
});
export const billDetailsListSelector = createSelector(stateSelector, state => state.billDetailsList);
export const billDetailsConfigSelector = createSelector(stateSelector, state => state.billDetailsConfig);
export const billDetailsSubGridConfigSelector = createSelector(stateSelector, state => state.billDetailsSubGridConfig);
export const titleInfoSelector = createSelector(stateSelector, state => state.titleInfo);
export const progressSelector = createSelector(stateSelector, state => state.progress);
export const bulkUpdateProgressSelector = createSelector(stateSelector, state => state.bulkUpdateProgress);
export const totalCountSelector = createSelector(stateSelector, state => state.totalCount);
export const listSelector = createSelector(stateSelector, state => state.data);

export const stateColorsSelector = createSelector(stateSelector, state => state.stateColors);

export const canCreateByFormSelector = createSelector([stateProfile, gridName], (state, name) => {
    const grid = state.grids && state.grids.find(item => item.name === name);
    return grid ? grid.canCreateByForm : false;
});

export const canImportFromExcelSelector = createSelector(
    [stateProfile, gridName],
    (state, name) => {
        const grid = state.grids && state.grids.find(item => item.name === name);
        return grid ? grid.canImportFromExcel : false;
    },
);

export const canExportToExcelSelector = createSelector([stateProfile, gridName], (state, name) => {
    const grid = state.grids && state.grids.find(item => item.name === name);
    return grid ? grid.canExportToExcel : false;
});

export const autogroupingOrdersSelector = createSelector([stateProfile, gridName], (state, name) => state.autogroupingOrders && name === ORDERS_GRID);

export const importProgressSelector = createSelector(stateSelector, state => state.importProgress);

export const exportProgressSelector = createSelector(stateSelector, state => state.exportProgress);

export const filtersSelector = createSelector(stateSelector, state => state.filters);

//*  SAGA  *//

export function* getListSaga({ payload }) {
    try {
        const { filter = {}, name, isConcat, scrollTop } = payload;

        const representation = yield select(state => representationFromGridSelector(state, name));
        const columns = representation ? representation.map(item => item.name) : [];

        const result = yield postman.post(`/${name}/search`, {
            ...filter,
            filter: {
                ...filter.filter,
                columns,
            },
        });

        yield put({ type: GET_GRID_LIST_SUCCESS, payload: { ...result, isConcat } });
        scrollTop && scrollTop();

    } catch (error) {
        yield put({ type: GET_GRID_LIST_ERROR, payload: error });
    }
}

export function* getBillDetailsListSaga({ payload }) {
    try {
        const { filter = {}, id, isConcat, scrollTop } = payload;

        const result = yield postman.post(`/billDetails/${id}/search`, {
            ...filter,
            filter: {
                ...filter.filter,
            },
        });

        yield put({ type: GET_BILL_DETAILS_LIST_SUCCESS, payload: result  });
        scrollTop && scrollTop();

    } catch (error) {
        yield put({ type: GET_BILL_DETAILS_LIST_ERROR, payload: error });
    }
}

export function* getBillDetailsByIdSaga({ payload }) {
    try {
        const { id } = payload;

        const result = yield postman.get(`/billDetails/${id}`);

        yield put({ type: GET_BILL_DETAILS_BY_ID_SUCCESS, payload: result });

    } catch (error) {
        yield put({ type: GET_BILL_DETAILS_BY_ID_ERROR });
    }
}

export function* getBillDetailsGridConfigSaga({ payload }) {
    try {
        const result = yield postman.get(`/billDetails/gridConfiguration`);

        yield put({ type: GET_BILL_DETAILS_GRID_CONFIG_SUCCESS, payload: result });

    } catch (error) {
        yield put({ type: GET_BILL_DETAILS_GRID_CONFIG_ERROR, payload: error });
    }
}

export function* getBillDetailsSubGridConfigSaga({ payload }) {
    try {
        const result = yield postman.get(`/billDetails/subGridConfiguration`);

        yield put({ type: GET_BILL_DETAILS_SUB_GRID_CONFIG_SUCCESS, payload: result });

    } catch (error) {
        yield put({ type: GET_BILL_DETAILS_SUB_GRID_CONFIG_ERROR, payload: error });
    }
}

function* billDetailsExportToExcelSaga({ payload }) {
    try {
        const { id } = payload;

        const res = yield downloader.post(
            `/billDetails/${id}/exportToExcel`,
            { },
            { responseType: 'blob' },
        );
        downloadFile(res);
        yield put({ type: BILL_DETAILS_EXPORT_TO_EXCEL_SUCCESS });
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const { t } = payload;
            toast.error(t("exportNotPossible.BillDetails"));
        }
        yield put({ type: BILL_DETAILS_EXPORT_TO_EXCEL_ERROR });
    }
}

function* billDetailsInvokeMassUpdateSaga({ payload }) {
    try {
        const { callbackSuccess, name, field, ids, value, callbackConfirmation, isConfirmed } = payload;
        const result = yield postman.post(`/billDetails/${name}/invokeBulkUpdate/${field}`, {
            ids,
            value: value && typeof value === 'object' ? value.value : value,
            isConfirmed,
        });
        if (result.needConfirmation) {
            callbackConfirmation && callbackConfirmation(result.confirmationMessage);
        } else {
            if (result.isError) {
                toast.error(result.message);
                yield put({
                    type: BILL_DETAILS_INVOKE_BULK_UPDATE_ERROR,
                    payload: result,
                });
            } else {
                yield put({
                    type: BILL_DETAILS_INVOKE_BULK_UPDATE_SUCCESS,
                });
                result.message && toast.info(result.message);
            }
            callbackSuccess && callbackSuccess();
        }

    } catch (e) {
        yield put({
            type: BILL_DETAILS_INVOKE_BULK_UPDATE_ERROR,
            payload: e,
        });
    }
}

export function* autoUpdateStartSaga({ payload }) {
    if (IS_AUTO_UPDATE) {
        if (!task) {
            yield put({
                type: SAVE_GRID_FILTERS,
                payload: {
                    ...payload,
                    isConcat: false,
                    notLoader: false,
                    filter: {
                        ...payload.filter,
                        take: payload.filter.take + payload.filter.skip,
                        skip: 0,
                    },
                }
            });
            task = yield fork(backgroundSyncListSaga);
        }
    } else {
        yield put(getListRequest(payload));
    }
}

export function* autoUpdateStopSaga({ payload = {} }) {
    if (task) {
        const { isClear } = payload;
        if (isClear) yield put(clearGridInfo());
        yield cancel(task);
        task = null;
        yield put({
            type: CLEAR_GRID_FILTERS
        })
    }
}

export const backgroundSyncListSaga = function*() {
    try {
        while (true) {
            const filters = yield select(filtersSelector);
            yield put(getListRequest(filters));
            yield put({
                type: SAVE_GRID_FILTERS,
                payload: {
                    ...filters,
                    notLoader: true,
                }
            });
            yield delay(30000);
        }
    } finally {
        if (yield cancelled()) {
            console.log('---', 'cancelled sync saga');
        }
    }
};

function* getStateColorsSaga({ payload }) {
    try {
        const result = yield postman.post(`${payload}/search`);

        yield put({
            type: GET_STATE_COLORS_SUCCESS,
            payload: result,
        });
    } catch (e) {
        yield put({
            type: GET_STATE_COLORS_ERROR,
            payload: e,
        });
    }
}

function* importFromExcelSaga({ payload }) {
    try {
        const { form, name, callbackSuccess } = payload;
        const result = yield postman.post(`${name}/importFromExcel`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (result.isError) {
            toast.error(result.message);
        } else {
            yield put({
                type: GRID_IMPORT_FROM_EXCEL_SUCCESS,
            });

            callbackSuccess();
        }
    } catch (e) {
        yield put({
            type: GRID_IMPORT_FROM_EXCEL_ERROR,
        });
    }
}

function* exportToExcelSaga({ payload }) {
    try {
        const { name, filter } = payload;
        const representation = yield select(state => representationFromGridSelector(state, name));
        const columns = representation ? representation.map(item => item.name) : [];

        const res = yield downloader.post(
            `/${name}/exportToExcel`,
            { columns, ...filter },
            { responseType: 'blob' },
        );

        downloadFile(res);
        yield put({ type: GRID_EXPORT_TO_EXCEL_SUCCESS });
    } catch (error) {
        yield put({ type: GRID_EXPORT_TO_EXCEL_ERROR });
    }
}

export function* saga() {
    yield all([
        takeEvery(GET_GRID_LIST_REQUEST, getListSaga),
        takeEvery(GRID_AUTO_UPDATE_START, autoUpdateStartSaga),
        takeEvery(GRID_AUTO_UPDATE_STOP, autoUpdateStopSaga),
        takeEvery(GET_STATE_COLORS_REQUEST, getStateColorsSaga),
        takeEvery(GRID_IMPORT_FROM_EXCEL_REQUEST, importFromExcelSaga),
        takeEvery(GRID_EXPORT_TO_EXCEL_REQUEST, exportToExcelSaga),
        takeEvery(GET_BILL_DETAILS_BY_ID_REQUEST, getBillDetailsByIdSaga),
        takeEvery(GET_BILL_DETAILS_GRID_CONFIG_REQUEST, getBillDetailsGridConfigSaga),
        takeEvery(GET_BILL_DETAILS_SUB_GRID_CONFIG_REQUEST, getBillDetailsSubGridConfigSaga),
        takeEvery(GET_BILL_DETAILS_LIST_REQUEST, getBillDetailsListSaga),
        takeEvery(BILL_DETAILS_EXPORT_TO_EXCEL_REQUEST, billDetailsExportToExcelSaga),
        takeEvery(BILL_DETAILS_INVOKE_BULK_UPDATE_REQUEST, billDetailsInvokeMassUpdateSaga),
    ]);
}
